module.exports = __webpack_public_path__ + "img/close.ac5b82e3.svg";